import React from 'react'
import Image from 'next/image';
import baronlogo from '../images/whoweare/baron_logo.svg';
import whtmanlogo from '../images/whoweare/whytman_logo.svg';
import salasarlogo from '../images/whoweare/salasar_logo.svg';
import larrow from '../images/whoweare/arrow-left.svg';
import rarrow from '../images/whoweare/arrow-right.svg';

import epoint from '../images/whoweare/earth_point_logo.svg';

import alloy_coated from '../images/whoweare/banner_logos/alloy-coated.png';
import alloy_coated2x from '../images/whoweare/banner_logos/alloy-coated@2x.png';

import back_fill from '../images/whoweare/banner_logos/backfill-compunds.png';
import back_fill2x from '../images/whoweare/banner_logos/backfill-compunds@2x.png';

import baron from '../images/whoweare/banner_logos/baron.png';
import baron2x from '../images/whoweare/banner_logos/baron@2x.png';

import conv from '../images/whoweare/banner_logos/conventional-lightning-protection.png';
import conv2x from '../images/whoweare/banner_logos/conventional-lightning-protection@2x.png';
import coppbond from '../images/whoweare/banner_logos/copper-bonded-rod.png';
import coppbond2x from '../images/whoweare/banner_logos/copper-bonded-rod@2x.png';

import copperplate from '../images/whoweare/banner_logos/copper-plated.png';
import coppperplate2x from '../images/whoweare/banner_logos/copper-plated@2x.png';

import cpri from '../images/whoweare/banner_logos/cpri.png';
import cpri2x from '../images/whoweare/banner_logos/cpri@2x.png';
import earthing_solution from '../images/whoweare/banner_logos/earthing-solution.png';
import earthing_solution2x from '../images/whoweare/banner_logos/earthing-solution@2x.png';
import earthpoint from '../images/whoweare/banner_logos/earthpoint.png';
import earthpoint2x from '../images/whoweare/banner_logos/earthpoint@2x.png';
import epcc from '../images/whoweare/banner_logos/epcc.png';
import epcc2x from '../images/whoweare/banner_logos/epcc@2x.png';
import galvanized from '../images/whoweare/banner_logos/galvanized.png';
import galvanized2x from '../images/whoweare/banner_logos/galvanized@2x.png';
import hizal from '../images/whoweare/banner_logos/hizal.png';
import hizal2x from '../images/whoweare/banner_logos/hizal@2x.png';
import icmet from '../images/whoweare/banner_logos/icmet.png';
import icmet2x from '../images/whoweare/banner_logos/icmet@2x.png';
import iika from '../images/whoweare/banner_logos/iika.png';
import iika2x from '../images/whoweare/banner_logos/iika@2x.png';
import ite from '../images/whoweare/banner_logos/ite.png';
import ite2x from '../images/whoweare/banner_logos/ite@2x.png';
import lightning_protection from '../images/whoweare/banner_logos/lightning-protection.png';
import lightning_protection2x from '../images/whoweare/banner_logos/lightning-protection@2x.png';
import nfc from '../images/whoweare/banner_logos/nfc.png';
import nfc2x from '../images/whoweare/banner_logos/nfc@2x.png';
import rohs from '../images/whoweare/banner_logos/rohs.png';
import rohs2x from '../images/whoweare/banner_logos/rohs@2x.png';
import salasar from '../images/whoweare/banner_logos/salasar.png';
import salasar2x from '../images/whoweare/banner_logos/salasar@2x.png';
import sentinel_earthing from '../images/whoweare/banner_logos/sentinel-earthing.png';
import sentinel_earthing2x from '../images/whoweare/banner_logos/sentinel-earthing@2x.png';
import singleton_earthing from '../images/whoweare/banner_logos/singleton-earthing.png';
import singleton_earthing2x from '../images/whoweare/banner_logos/singleton-earthing@2x.png';
import ul from '../images/whoweare/banner_logos/ul.png';
import ul2x from '../images/whoweare/banner_logos/ul@2x.png';
import whytman from '../images/whoweare/banner_logos/whytman.png';
import whytman2x from '../images/whoweare/banner_logos/whytman@2x.png';
import zinc_coated from '../images/whoweare/banner_logos/zinc-coated.png';
import zinc_coated2x from '../images/whoweare/banner_logos/zinc-coated@2x.png';

import iec from '../images/whoweare/banner_logos/iec.png';
import iec2x from '../images/whoweare/banner_logos/iec@2x.png';

import iso from '../images/whoweare/banner_logos/iso.png';
import iso2x from '../images/whoweare/banner_logos/iso@2x.png';

// import Carousel from 'react-multi-carousel';
// import 'react-multi-carousel/lib/styles.css';
// import './hcarsol.css';
// import InfiniteScrollCarousel from './InfiniteScrollCarousel';
import Infinitescrollnew from './Infinitescrollnew';

//import './carsoulheight.css';


//import {Carousel} from 'react-responsive-carousel';
//https://www.youtube.com/watch?v=VFHWuy2olto
//import banner1 from './assets/images/Banner1.jpg'
//import "react-responsive-carousel/lib/styles/carousel.min.css"; 
//import banner1 from './assets/images/whoweare/logo_1.png';
//import banner1_2x from './assets/images/whoweare/logo_1_2x.png';
//import banner2 from './assets/images/whoweare/logo_2.png';
//import banner2_2x from './assets/images/whoweare/logo_2_2x.png';



const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
    slidesToSlide: 1 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 3,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 767, min: 464 },
    items: 2,
    slidesToSlide: 1 // optional, default to 1.
  }
};

const sliderImageUrl = [
  //First image url
   {
    url:alloy_coated,
    url2x:alloy_coated2x,
    alt:'Alloy Coated Electrode - Ashlok Safe Earthing Electrode Limited alloy coated electrodes for advanced earthing solutions'
  },
  {
    url:back_fill,
    url2x:back_fill2x,
    alt:'Backfill Compound for Safe Earthing Solutions - Ashlok Safe Earthing Electrode Limited'
  },
  {
    url:baron,
    url2x:baron2x,
    alt:'Boron Compound - Ashlok Safe Earthing Electrode Limited boron compound for enhancing earthing performance.'
  },
  {
    url:conv,
    url2x:conv2x,
    alt:'Conventional Lightning Protection System - Ashlok Safe Earthing Electrode Limited conventional lightning protection system for complete lightning safety.'
  },
  {
    url:coppbond,
    url2x:coppbond2x,
    alt:'Copper Bonded Rod - Ashlok Safe Earthing Electrode Limited copper bonded rods for high-performance earthing systems'
  },
 {
    url:copperplate,
    url2x:coppperplate2x,
    alt:'Copper Plated Electrode - Ashlok Safe Earthing Electrode Limited copper plated electrodes for reliable earthing solutions'
  },
 {
    url:cpri,
    url2x:cpri2x,
    alt:'Cpri Logo | Ashlok Safe Earthing Electrodes Manufacturer & Supplier'
   
  },
 {
    url:earthing_solution,
    url2x:earthing_solution2x,
    alt:'Earthing Solution Logo | Ashlok Safe Earthing Electrodes Manufacturer & Supplier'
  },
 {
    url:earthpoint,
    url2x:earthpoint2x,
    alt:'Earth Point Logo | Ashlok Safe Earthing Electrodes Manufacturer & Supplier'
  },
 {
    url:epcc,
    url2x:epcc2x,
    alt:'EPCC Logo | Ashlok Safe Earthing Electrodes Manufacturing and Installation Services'
  
  },
 {
    url:galvanized,
    url2x:galvanized2x,
    alt:'Galvanized Electrodes Logo | Ashlok Safe Earthing Electrodes Manufacturing and Installation Services'
  },
 {
    url:hizal,
    url2x:hizal2x,
    alt:'Hizal Logo | Trusted Client of Ashlok Safe Earthing Electrodes Manufacturer & Supplier'
  },
 {
    url:icmet,
    url2x:icmet2x,
    alt:'ICMET Certified Logo - Ashlok Safe Earthing Electrodes tested and certified by ICMET for quality and safety'
  },
//  {
//     url:iika,
//     url2x:iika2x
//   },
 {
    url:ite,
    url2x:ite2x,
    alt:'ITE Instituto Tecnológico Logo - Ashlok Safe Earthing Electrodes tested by ITE for international energy standards compliance'
    
},
{
    url:lightning_protection,
    url2x:lightning_protection2x,
    alt:'Lightning Protection Logo - Ashlok Safe Earthing Electrode Limited'
  },
{
    url:nfc,
    url2x:nfc2x,
    alt:'NFC Certified Logo - Ashlok Safe Earthing Electrodes certified by NFC 17-102 for reliable lightning protection systems'
  },
{
    url:rohs,
    url2x:rohs2x,
    alt:'RoHS Certified Logo - Ashlok Safe Earthing Electrode Limited Compliance'
  },
{
    url:salasar,
    url2x:salasar2x,
    alt:'Salasar Technologies Logo - Partner with Ashlok Safe Earthing Electrode Limited'
  },
{
    url:sentinel_earthing,
    url2x:sentinel_earthing2x,
    alt:'Sentinel Earthing Electrode Logo - Ashlok Safe Earthing Electrode Limited Collaboration'
  },
{
    url:singleton_earthing,
    url2x:singleton_earthing2x,
    alt:'Singleton Earthing EcoSystem Logo - Supported by Ashlok Safe Earthing Electrode Limited'
  },
{
    url:ul,
    url2x:ul2x,
    alt:'UL Certified Logo - Ashlok Safe Earthing Electrode Limited Certified Product'
  },
{
    url:whytman,
    url2x:whytman2x,
    alt:'Whytman Technologies Logo - Trusted partnership with Whytman Technologies for earthing and lightning protection'
  },
{
    url:zinc_coated,
    url2x:zinc_coated2x,
    alt:'Zinc Coated Electrode - Ashlok Safe Earthing Electrode Limited zinc coated electrodes for long-lasting earthing protection.'
  },

  {
    url:iec,
    url2x:iec2x,
    alt:'IEC 62305 Logo - Ashlok Safe Earthing Electrodes compliant with IEC 62305 lightning protection standards.'
  },

  {
    url:iso,
    url2x:iso2x,
    alt:'ISO Logo - Ashlok Safe Earthing Electrodes compliant with IEC 62305 lightning protection standards.'
  }

 
];






const WhoweareContent = () => {
  return (
    <>
   
    <div className=' w-full   bg-ashred flex flex-col justify-center items-center'>
        <div className=' text-2xl lg:text-3xl   text-white p-2 underline-offset-auto font-semibold' style={{ fontFamily: 'cinzel, sans-serif' }}><span className='vollkorn-sc-semibold'>Ashlok</span> Family</div>
    </div>
    <div className=' w-full  flex flex-col  justify-center items-center my-3 lg:my-0 lg:mb-3'>
        {/*<div className=' text-3xl text-ashred'>Group Of Companies</div>*/}
        <div className='container mx-auto max-w-screen-xl flex flex-col md:flex-row '>
            <div className='flex   w-full  lg:basis-1/3  items-center md:items-end  justify-center lg:justify-start'>
                <Image  className='  w-4/6 md:w-[22em] lg:w-3/4 ' src={baronlogo} alt="baron logo"/>
            </div>
            <div className='flex  w-full lg:basis-1/3 items-center md:items-end justify-center'>
            <Image className=' w-8/12 md:w-9/12 lg:w-3/4 mt-1 my-0 h-[100%] lg:h-[81%]' src={whtmanlogo} alt="whytman logo" />
        

            </div>
            <div className='flex w-full lg:basis-1/3 items-center md:items-end  justify-center  lg:justify-end'>
            <Image  className='w-8/12 md:w-9/12 lg:w-1/2 my-0 ' src={salasarlogo} alt="salasar lgo " />
            </div>
        </div>

        
    </div>
    <div className=' w-full  flex flex-col lg:flex-row justify-center items-center'>
        <div className=' lg:text-3xl  sm:text-xl text-ashred px-2 sm:px-2 md:px-2 lg:px-0'>Certification(<span style={{fontSize:'80%'}}>s</span>) <span className=' lg:text-4xl  sm:text-2xl px-1'>|</span> Trademark(<span style={{fontSize:'80%'}}>s</span>) <span className=' lg:text-4xl sm:text-2xl px-1'>|</span> Brand(<span style={{fontSize:'80%'}}>s</span>) <span className=' lg:text-4xl sm:text-2xl px-1'>|</span> Product(<span style={{fontSize:'80%'}}>s</span>)</div>
    </div>
   
    <div className=' w-full  bg-white flex flex-col justify-center items-center'>
        <div className='container mx-auto max-w-screen-xl pt-1 pb-2' id="who">
                
        <Infinitescrollnew images={sliderImageUrl}/>

         </div>
    </div>
    </>
  )
}

export default WhoweareContent
